import React, { useEffect, useRef, useState } from "react";
import { X, Eye } from "lucide-react";
import { Facebook, Instagram, Linkedin, Twitter } from "lucide-react";
import axios from "axios";

import { useSelector } from "react-redux";
import { apiUrl } from "../../config/Config";
import Select from "react-select";
import Swal from "sweetalert2";
import ProgressBar from "@ramonak/react-progress-bar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronDown,
  faXmark,
  faCheck,
} from "@fortawesome/free-solid-svg-icons";
import Spinner from "react-activity/dist/Spinner";
import "react-activity/dist/Spinner.css";
import TagsInput from "react-tagsinput";
import "react-tagsinput/react-tagsinput.css";


const CreatePostModal = ({ isOpen, onClose, selectedPage, allpages }) => {
  console.log('allpages >>', allpages);
  const [content, setContent] = useState("");
  const [tags, setTags] = useState([]);
  const [mediaurl, setmediaurl] = useState("");
  const [scheduleDate, setScheduleDate] = useState("");
  const [scheduledatetime, setscheduledatetime] = useState("");
  const [loading, setLoading] = useState(false);
  const [feedbackMessage, setFeedbackMessage] = useState("");
  const userdata = useSelector((store) => store.userReducer.userdata);
  /** ===================*/
  const [currentstep, setCurrentStep] = useState(1);

  const completedbarcountRef = React.useRef(12);
  const stateresultarrRef = React.useRef([]);
  const profilematchcandidatedataRef = React.useRef(null);
  const overallresultrespRef = React.useRef(null);
  const [completedbarcount, setcompletedbarcount] = useState(12);

  const [storeresultloading, setstoreresultloading] = useState(false);

  const [selectedPlatforms, setSelectedPlatforms] = useState([]);

  completedbarcountRef.current = completedbarcount;

  // const platforms = [
  //   { name: "Facebook", icon: Facebook, color: "#1877F2", isselected: "false", pageid: "123456789" },
  //   { name: "Instagram", icon: Instagram, color: "#E1306C", isselected: "false", pageid: "" },
  //   { name: "LinkedIn", icon: Linkedin, color: "#0A66C2", isselected: "false", pageid: "" },
  //   { name: "Twitter", icon: Twitter, color: "#1DA1F2", isselected: "false", pageid: "" }
  // ];

  const [pleatformsarr, setpleatformsarr] = useState({});
  const pleatformsarrRef = useRef({});
  pleatformsarrRef.current = pleatformsarr;
  const [forcestateupdate, setforcestateupdate] = useState(false);
  const [selectedplarformsarr, setselectedplarformsarr] = useState([]);

  const [selectedpublishtype, setselectedpublishtype] = useState('now');

  const [selectedposttype, setselectedposttype] = useState('photos');


  const togglepublishtype = (type) => {
    setselectedpublishtype(type);
  }

  const toggleposttype = (type) => {
    setselectedposttype(type);
  }

  const handlePlatformChange = (index) => {
    // setSelectedPlatforms((prev) =>
    //   prev.includes(index)
    //     ? prev.filter((p) => p !== platform)
    //     : [...prev, platform]
    // );
    var prevdata = pleatformsarrRef.current;
    prevdata[index]['isselected'] = prevdata[index]['isselected'] == "true" ? "false" : "true";
    console.log('prevdata >>', prevdata[index]);
    setpleatformsarr(prevdata);
    setforcestateupdate(!forcestateupdate);
    
  };

  const togglemultiplepgaescheckbox = (key, index) => {
    // console.log('key >>', key);
    // console.log('index >>', index);
    var prevdata = pleatformsarrRef.current;
    // console.log('test >>',  prevdata[key]);
    prevdata[key]['pagelist'][index]['isselected'] = prevdata[key]['pagelist'][index]['isselected'] == "true" ? "false" : "true";
    setpleatformsarr(prevdata);
    setforcestateupdate(!forcestateupdate);
  }

  const handletogglestep = (step) => {
    setCurrentStep(step);
  };

  const resetForm = () => {
    setContent("");
    setTags("");
    setScheduleDate("");
    setFeedbackMessage("");
  };

  const handleSave = async () => {
    setFeedbackMessage("");

    if (!content.trim()) {
      setFeedbackMessage("⚠️ Please enter post/feed content.");
      return;
    }

    if (!selectedPage || !selectedPage.id || !selectedPage.access_token) {
      setFeedbackMessage("⚠️ Facebook Page not selected.");
      return;
    }

    setLoading(true);

    try {
      const data = {
        pageId: selectedPage.id,
        pageAccessToken: selectedPage.access_token,
        content,
        tags,
        // scheduleDate,
      };

      const headers = {
        headers: {
          Authorization: `Bearer ${userdata?.token}`,
        },
      };

      const res = await axios.post(apiUrl + "createpostfb", data, headers);

      if (res.data?.status === "success") {
        setFeedbackMessage("✅ Post published to Facebook Page!");
        setTimeout(() => {
          onClose();
          resetForm();
        }, 1500);
      } else {
        setFeedbackMessage(
          `❌ Failed: ${res.data?.message || "Unknown error"}`
        );
      }
    } catch (err) {
      setFeedbackMessage(
        `❌ Error: ${err.response?.data?.message || err.message}`
      );
    } finally {
      setLoading(false);
    }
  };

  const handlesavecontent = async () => {
    if (!content.trim()) {
      // setFeedbackMessage('⚠️ Please enter post/feed content.');
      // return;
      Swal.fire({
        title: "",
        text: " Please enter post/feed content",
        icon: "warning",
        customClass: {
          icon: "custom-swal-icon", // Apply the custom class
        },
        width: "350px",
        confirmButtonText: "Ok",
        confirmButtonColor: "rgb(59, 151, 196)",
        customClass: {
          popup: "small-icon-alert",
        },
      });
      return;
    }
    if(selectedposttype == 'photos' || selectedposttype == 'videos') {
      if(mediaurl) {

      } else {
        Swal.fire({
          title: "",
          text: "Media Url is mandatory for photos/videos",
          icon: "warning",
          customClass: {
            icon: "custom-swal-icon", // Apply the custom class
          },
          width: "350px",
          confirmButtonText: "Ok",
          confirmButtonColor: "rgb(59, 151, 196)",
          customClass: {
            popup: "small-icon-alert",
          },
        });
        return;
      }
    }
    handletogglestep(2);
    setcompletedbarcount(52);
    setselectedplarformsarr([]);
  };

  const handlesavepublishplatforms = async () => {
    setselectedplarformsarr([]);
    var prevdata = pleatformsarrRef.current;
    var newarr = [];
    // for(var i = 0; i < prevdata?.length; i++) {
    //   if(prevdata[i]['isselected'] == "true") {
    //     newarr.push(prevdata[i]);
    //   }
    // }
    var prevdatakeys = Object.keys(prevdata);
    for(var i = 0; i < prevdatakeys?.length; i++) {
      if(prevdata[prevdatakeys[i]]?.pagelist?.length > 0) {
        var pagelistarr = prevdata[prevdatakeys[i]]?.pagelist;
        for(var p = 0; p < pagelistarr?.length; p++) {
            if(pagelistarr[p]['isselected'] == "true") {
              newarr.push(pagelistarr[p]);
            }
        }
      }
    }
    console.log('newarr >>', newarr);
    if(newarr?.length > 0) {
      setselectedplarformsarr(newarr);
      handletogglestep(3);
      setcompletedbarcount(88);
    } else {
      setselectedplarformsarr([]);
      Swal.fire({
        title: "",
        text: " Please select platforms to publish",
        icon: "warning",
        customClass: {
          icon: "custom-swal-icon", // Apply the custom class
        },
        width: "350px",
        confirmButtonText: "Ok",
        confirmButtonColor: "rgb(59, 151, 196)",
        customClass: {
          popup: "small-icon-alert",
        },
      });
    }
    
    

    
  }

  const handlesavescheduletime = async () => {
    
    if(selectedpublishtype == "now") {

    } else {
      if(scheduledatetime) {
        // const istDateString = formatToIST(scheduledatetime);
        // console.log('istDateString >>', istDateString);
      } else {
        Swal.fire({
          title: "",
          text: " Please select date and time to publish post for later.",
          icon: "warning",
          customClass: {
            icon: "custom-swal-icon", // Apply the custom class
          },
          width: "350px",
          confirmButtonText: "Ok",
          confirmButtonColor: "rgb(59, 151, 196)",
          customClass: {
            popup: "small-icon-alert",
          },
        });
        return
      }
    }
    functiontosubmitpost();
  }

  const functiontosubmitpost = async() => {
    var data = {
      type: selectedposttype,
      content: tags ? `${content}\n\n${tags.join(' ')}` : content,
      hashtags: tags,
      mediaurl: mediaurl,
      selectedplatforms: selectedplarformsarr,
      publishtype: selectedpublishtype,
      scheduleDate: scheduledatetime ? formatToIST(scheduledatetime) : "",
    }
    const headers = {
      headers: {
        Authorization: `Bearer ${userdata?.token}`,
      },
    };

    const res = await axios.post(apiUrl + "createpostfb", data, headers);

    if (res.data?.status === "success") {
      
    } else {
      
    }
  } 

  const formatToIST = (datetime) => {
    const options = {
      timeZone: 'Asia/Kolkata',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    };
  
    const formatter = new Intl.DateTimeFormat('en-GB', options);
    const parts = formatter.formatToParts(new Date(datetime));
    const get = type => parts.find(p => p.type === type)?.value;
  
    return `${get('year')}-${get('month')}-${get('day')} ${get('hour')}:${get('minute')}:${get('second')}`;
  }


  useEffect(() => {
    if(allpages?.length > 0) {
      var allpagesarr = {
        "Facebook": {icon: Facebook, color: "#1877F2", pagelist: []},
        "Instagram": {icon: Instagram, color: "#1877F2", pagelist: []},
        "LinkedIn": {icon: Linkedin, color: "#1877F2", pagelist: []},
        "Twitter": {icon: Twitter, color: "#1877F2", pagelist: []}
      }
      
      var fbarray = [];
      for(var i = 0; i < allpages?.length; i++) {
        var obj={};
        obj['id'] = allpages[i]?.id;
        obj['access_token'] = allpages[i]?.access_token;
        obj['name'] = allpages[i]?.name;
        obj['isselected'] = "false";
        fbarray.push(obj);
      }
      allpagesarr["Facebook"]["pagelist"] = fbarray;
      setpleatformsarr(allpagesarr);
    }
  }, [allpages])

  if (!isOpen) return null;

  return (
    <div className="createpost-modal-overlay">
      <div className="createpost-modal-container">
        <div className="createpost-modal-header">
          <h2 className="createpost-modal-title">Create New Post</h2>
          <button
            className="createpost-modal-close-btn"
            onClick={() => {
              onClose();
              resetForm();
            }}
          >
            <X className="createpost-modal-close-icon" />
          </button>
        </div>

        {feedbackMessage && (
          <div className="createpost-modal-alert">{feedbackMessage}</div>
        )}

        <div className="webadmin-modalmainbody mt-5">
          <div className="progressbar-maindiv1">
            <div className="progressbar-maindiv">
              <ProgressBar
                completed={completedbarcountRef.current}
                isLabelVisible={false}
                bgColor={"#3F9BD3"}
              />
            </div>
          </div>

          <div className="progressbar-numberdiv">
            <div
              className="step1div"
              onClick={() => {
                // handletogglestep(1);
                // setcompletedbarcount(12);
              }}
            >
              <div className="step1divround">
                <p>1</p>
              </div>
            </div>
            <div
              className="step1div"
              onClick={() => {
                // handletogglestep(2);
                // setcompletedbarcount(52);
              }}
            >
              <div className="step1divround">
                <p>2</p>
              </div>
            </div>
            <div
              className="step1div"
              onClick={() => {
                // handletogglestep(3);
                // setcompletedbarcount(88);
              }}
            >
              <div className="step1divround">
                <p>3</p>
              </div>
            </div>
            {/* <div className="step1div" onClick={() => setcompletedbarcount(87)}>
                    <div className="step1divround"><p>4</p></div>
                  </div> */}
          </div>

          <div className="progressbar-numberdiv progressbar-numberdiv1">
            <div
              className="step1div"
              onClick={() => {
                // handletogglestep(1);
                // setcompletedbarcount(12);
              }}
            >
              <p className="progressbar-labeldiv">Platforms</p>
            </div>
            <div
              className="step1div"
              onClick={() => {
                // handletogglestep(2);
                // setcompletedbarcount(52);
              }}
            >
              <p className="progressbar-labeldiv">Post Content</p>
            </div>
            <div
              className="step1div"
              onClick={() => {
                // handletogglestep(3);
                // setcompletedbarcount(88);
              }}
            >
              <p className="progressbar-labeldiv">Schedule</p>
            </div>
          </div>

          <div className="progress-body-div">
            {currentstep == 1 ? (
              <div className="progress-body-div1">
                <div className="createpost-modal-body">
                <div className="publishrow">
                    <div className="publishdivrow">
                      <input
                       checked={selectedposttype == "photos" ? true : false}
                        onChange={() => toggleposttype("photos")}
                          type="checkbox"
                          className="publishdivcheckbox"
                        />
                        <p>Photos</p>
                    </div>
                    <div className="publishdivrow publishdivrow1">
                      <input
                       checked={selectedposttype == "videos" ? true : false}
                       onChange={() => toggleposttype("videos")}
                          type="checkbox"
                          className="publishdivcheckbox"
                        />
                        <p>Videos</p>
                    </div>
                    <div className="publishdivrow publishdivrow1">
                      <input
                       checked={selectedposttype == "feed" ? true : false}
                       onChange={() => toggleposttype("feed")}
                          type="checkbox"
                          className="publishdivcheckbox"
                        />
                        <p>Feed</p>
                    </div>
                  </div>
                  <div className="createpost-field">
                    <label className="createpost-label">
                      Feed/Post Description
                    </label>
                    <textarea
                      className="createpost-textarea"
                      rows="3"
                      value={content}
                      onChange={(e) => setContent(e.target.value)}
                      placeholder="Write your post here…"
                      disabled={loading}
                    />
                  </div>

                  <div className="createpost-field">
                    <label className="createpost-label">(Optional) Enter HastTags e.g #Hello and press enter to add another</label>
                    {/* <input
                      type="text"
                      className="createpost-input"
                      value={tags}
                      onChange={(e) => setTags(e.target.value)}
                      placeholder="#launch #promo"
                      disabled={loading}
                    /> */}
                    <TagsInput
                                        value={tags}
                                        onChange={(options) => {
                                          setTags(options);
                                        }}
                                        placeholder={"Enter HastTags e.g #Hello #World"}
                                        inputProps={{
                                          className: "react-tagsinput-input",
                                          placeholder: "",
                                        }}
                                        className="form-control tagsinputbox1"
                                      />
                  </div>

                  {/* <div className="newuser-field">
                        <label>Upload Image or Video</label>
                        <input type="file" name="media" accept="image/*,video/*" />

                    </div> */}
                    {
                      selectedposttype == 'photos' || selectedposttype == 'videos' ?
                      <div className="createpost-field">
                    <label className="createpost-label">Media URL</label>
                    <input
                      type="text"
                      value={mediaurl}
                      onChange={(e) => setmediaurl(e.target.value)}
                      className="createpost-input"
                      placeholder="Media URL"
                    />
                  </div> : null
                    }
                  

                  <div className="createpost-modal-footer">
                    <button
                      onClick={() => {
                        onClose();
                        resetForm();
                      }}
                      className="createpost-btn-cancel"
                      disabled={loading}
                    >
                      Cancel
                    </button>
                    <button
                      onClick={handlesavecontent}
                      className="createpost-btn-save"
                      disabled={loading}
                    >
                      {loading ? "Posting..." : "Continue"}
                    </button>
                  </div>
                </div>
              </div>
            ) : currentstep == 2 ? (
              <div className="progress-body-div1">
                <div className="createpost-field">
                  <label className="createpost-label">
                    Publish to Platforms
                  </label>
                  <div className="platforms-container">
                    {/* {pleatformsarrRef.current.map((item, index) => {
                      const Tagname = item?.icon;
                      // console.log('item >>', item);
                      return (
                        <label
                        key={item?.name}
                        className={`platform-item ${
                          selectedPlatforms.includes(item?.name) ? "selected" : ""
                        }`}
                        
                      >
                        <input
                        onChange={() => handlePlatformChange(index)}
                          type="checkbox"
                          checked={item?.isselected == "true" ? true : false}
                          readOnly
                        />
                        <Tagname size={16} color={item?.color} />
                        <span>{item?.name}</span>
                      </label>
                      )
                    })} */}
                  </div>
                  <div className="platforms-container-new">
                  {Object.keys(pleatformsarrRef.current).map((item, index) => {
                      // const Tagname = item?.icon;
                      console.log('pp item >>',pleatformsarrRef.current[item]);
                      return (
                        <div key={index} >
                          <div className="platformtitlediv">
                            <p className="platformtitle">{index + 1 +'. ' + item}</p>
                          </div>
                          
                            {
                              pleatformsarrRef.current[item]?.pagelist?.length > 0 ?
                              <div className="platformlistdiv">
                                {
                                  pleatformsarrRef.current[item]?.pagelist?.map((pitem, pindex) => {
                                    return (
                                      <div className="publishdivrow">
                                        <input
                                          checked={
                                            pitem?.isselected == "true" ? true : false
                                          }
                                          onChange={() =>
                                            togglemultiplepgaescheckbox(item, pindex)
                                          }
                                          type="checkbox"
                                          className="publishdivcheckbox"
                                        />
                                        <p>{pitem?.name}</p>
                                      </div>
                                    );
                                  })
                                }
                              </div>
                              : null
                            }
                          
                        </div>
                      )
                    })}
                  </div>
                  
                  <div className="createpost-modal-footer">
                    <button
                      onClick={() => {
                        handletogglestep(1);
                setcompletedbarcount(12);
                      }}
                      className="createpost-btn-cancel"
                      disabled={loading}
                    >
                      {"Back"}
                    </button>
                    <button
                      onClick={handlesavepublishplatforms}
                      className="createpost-btn-save"
                      disabled={loading}
                    >
                      {loading ? "Posting..." : "Continue"}
                    </button>
                  </div>
                </div>

                {/* <div className="resultdiv-progress">
                      <p className="candidate-name" style={{ textAlign: 'center' }}>
                        <b>No response to show</b>
                      </p>
                    </div> */}
              </div>
            ) : currentstep == 3 ? (
              <div className="progress-body-div1">
                <div className="resultdiv-progress">
                  <div className="publishrow">
                    <div className="publishdivrow">
                      <input
                       checked={selectedpublishtype == "now" ? true : false}
                        onChange={() => togglepublishtype("now")}
                          type="checkbox"
                          className="publishdivcheckbox"
                        />
                        <p>Publish Now</p>
                    </div>
                    <div className="publishdivrow publishdivrow1">
                      <input
                       checked={selectedpublishtype == "later" ? true : false}
                       onChange={() => togglepublishtype("later")}
                          type="checkbox"
                          className="publishdivcheckbox"
                        />
                        <p>Publish Later</p>
                    </div>
                  </div>
                  {
                    selectedpublishtype == "later" ?
                    <div className="createpost-field mt-3">
                    <label className="createpost-label">Schedule Date & Time</label>
                    <input
                      type="datetime-local"
                      className="createpost-input scheduledatetimeinput"
                      value={scheduledatetime}
                      onChange={(e) => setscheduledatetime(e.target.value)}
                    />
                  </div> : null
                  }
                
                  <div className="createpost-modal-footer">
                    <button
                      onClick={() => {
                       handletogglestep(2);
                setcompletedbarcount(52);
                      }}
                      className="createpost-btn-cancel"
                      disabled={loading}
                    >
                      {"Back"}
                    </button>
                    <button
                      onClick={handlesavescheduletime}
                      className="createpost-btn-save"
                      disabled={loading}
                    >
                      {loading ? "Posting..." : "Publish"}
                    </button>
                  </div>
                </div>
              </div>
            ) : null}
          </div>

          {/* <div className="col-md-12 mt-4">
                <div
                  className="formsubmitbtn"
                  onClick={() => {
                    submithandle();
                  }}
                >
                  <p>Submit</p>
                </div>
              </div> */}
        </div>
      </div>
    </div>
  );
};

export default CreatePostModal;
